import {
  Paper, Typography, Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, Skeleton
} from '@mui/material';
import { formatMoney } from '../../../utils/currency';

const MostSoldProductsTable = ({ data = [], loading }) => {
  return (
    <Paper elevation={2} sx={{ p: 2 }}>
      <Typography variant="subtitle1" gutterBottom>
        ⭐ Productos más vendidos del mes
      </Typography>

      {loading ? (
        <Skeleton variant="rectangular" height={300} />
      ) : (
        <TableContainer sx={{ maxHeight: 300, overflow: 'auto' }}>
          <Table size="small" stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell>Producto</TableCell>
                <TableCell align="center">Cantidad</TableCell>
                <TableCell align="right">Total</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((prod, idx) => (
                <TableRow key={idx}>
                  <TableCell>{prod.product}</TableCell>
                  <TableCell align="center">{prod.quantity}</TableCell>
                  <TableCell align="right">{formatMoney(prod.revenue)}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Paper>
  );
};

export default MostSoldProductsTable;
